'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var FEATURE_QUERY_VALUE = 'feature:query:value';
var FEATURE_QUERY_ENABLED = 'feature:query:enabled';
var FEATURE_QUERY_ACTIVE = 'feature:query:active';
var FEATURE_UPDATED = 'feature:updated';
(function (Feature) {
    // Boolean based values
    Feature["COOKIE_POPUP"] = "cookie-popup";
    Feature["FAQS"] = "faqs";
    Feature["RESPONSIBLE_GAMING_PAGE"] = "responsible-gaming-page";
    Feature["ABOUT_US"] = "about-us";
    Feature["MESSAGES"] = "messages";
    Feature["LEADERBOARDS"] = "leaderboards";
    Feature["PROMOTIONS"] = "promotions";
    Feature["REWARDS"] = "rewards";
    Feature["MARKETING_PREFERENCES"] = "marketing-preferences";
    Feature["VERIFICATION"] = "verification";
    Feature["SOURCE_OF_WEALTH"] = "source-of-wealth";
    Feature["RESPONSIBLE_GAMING_QUESTIONNAIRE"] = "responsible-gaming-questionnaire";
    Feature["TOURNAMENTS"] = "tournaments";
    Feature["QUICK_DEPOSIT"] = "quick-deposit";
    Feature["PASSWORD_RESET_EMAIL"] = "password-reset-email";
    Feature["PASSWORD_RESET_SMS"] = "password-reset-sms";
    Feature["LOYALTY_PROGRESS_BAR"] = "loyalty-progress-bar";
    Feature["LOYALTY_PROGRESS_BAR_GAME_NAVIGATION"] = "loyalty-progress-bar-game-navigation";
    Feature["SHOP"] = "shop";
    Feature["HYBRID_PNP_BONUS_NOTIFICATION"] = "hybrid-pay-and-play-bonus-notification";
    Feature["SEO_TEXT_GAMES_CATEGORIES"] = "seo-text-games-categories";
    Feature["DYNAMIC_OPTION_MOBILE_BOTTOM_MENU"] = "dynamic-option-mobile-bottom-menu";
    Feature["REWARD_DETAIL_IMAGE"] = "reward-details-image";
    Feature["COLLAPSIBLE_MARKETING_PREFERENCES"] = "collapsible-marketing-preferences";
    Feature["DISPLAY_MESSAGE_IMAGE"] = "display-message-image";
    Feature["BANK_ID_REGISTRATION_SECURITY_QUESTIONS"] = "bank-id-registration-security-questions";
    Feature["WAKE_LOCK"] = "wake-lock";
    Feature["MAIL_CHECK"] = "mail-check";
    Feature["AMEND_DOB_HINT"] = "amend-dob-hint";
    Feature["VERIFICATION_EMAIL_CLIENTS"] = "verification-email-clients";
    Feature["REWARDS_DATE_FILTER"] = "rewards-date-filter";
    Feature["BANK_ID_ENABLED"] = "bank-id-enabled";
    Feature["BONUS_TRANSACTION_HISTORY"] = "bonus-transaction-history";
    Feature["UNMASK_PASSWORD"] = "unmask-password";
    Feature["STATUS_PAYMENT_TRANSACTIONS"] = "status-payment-transactions";
    Feature["GRE_TRACKING_EVENTS"] = "gre-tracking-events";
    Feature["SUBDIVISION_REQUIRED"] = "subdivision-required";
    Feature["PROMOTION_GAMES"] = "promotion-games";
    Feature["WALLET_METHOD_REMOVAL"] = "wallet-method-removal";
    Feature["REMAINING_DEPOSIT_LIMIT_AMOUNT"] = "remaining-deposit-limit-amount";
    Feature["HREFLANG_ON_PAGE"] = "hreflang-on-page";
    Feature["SHOW_EXPIRY_DATE"] = "expiry-date-on-rewards";
    Feature["SPORTNCO_META_CONTENT"] = "sportnco-meta-content";
    Feature["AGCO_TOP_BAR"] = "agco-top-bar";
    Feature["DISABLE_WITHDRAWAL_REVERSE"] = "disable-withdrawal-reverse";
    Feature["SPORTSBOOK"] = "sportsbook";
    Feature["ENHANCED_LIMITS"] = "enhanced-limits";
    Feature["SHOW_SHOP_SELECTION_SCREEN"] = "show-shop-selection-screen";
    Feature["SPORTSBOOK_CAROUSEL"] = "sportsbook-carousel";
    Feature["SCAN_VERIFY_FLOW"] = "scan-verify-flow";
    Feature["CUSTOM_WELCOME_OFFER_BASED_ON_BTAG"] = "custom-welcome-offer-based-on-btag";
    Feature["MYSTERY_REWARDS"] = "mystery-rewards";
    Feature["FREE_TO_PLAY_LOBBY"] = "free-to-play-lobby";
    Feature["LOYALTY_PROGRAM"] = "loyalty-program";
    // String array values
    Feature["ACCOUNT_MENU"] = "account-menu";
    Feature["PASSWORD_RESET"] = "password-reset";
    Feature["TWO_FACTOR_AUTHENTICATION_SIGN_UP"] = "two-factor-authentication-sign-up";
    Feature["TWO_FACTOR_AUTHENTICATION_MY_ACCOUNT"] = "two-factor-authentication-my-account";
    Feature["GAMES_PROVIDERS_FILTER"] = "games-providers-filter";
    Feature["HYBRID_PAY_AND_PLAY"] = "hybrid-pay-and-play";
    Feature["PURE_PAY_AND_PLAY"] = "pure-pay-and-play";
    Feature["PURE_PAY_AND_PLAY_COLLECT_MARKETING_INFO"] = "pure-pay-and-play-collect-marketing-info";
    Feature["SOCIAL_MEDIA_ICONS_FOOTER"] = "social-media-icons-footer";
    Feature["QUICK_DEPOSIT_PROVIDERS_RELOAD"] = "quick-deposit-providers-reload";
    Feature["RECOMMENDED_GAMES_MARKET"] = "recommended-games-market";
    Feature["RECOMMENDED_GAMES_USER"] = "recommended-games-user";
    Feature["SEASONAL_REWARD"] = "seasonal-reward";
    Feature["GAMEPLAY_INFORMATION_DISABLED"] = "gameplay-information-disabled";
    Feature["RESPONSIBLE_GAMING_FEATURES"] = "responsible-gaming-features";
    Feature["WHEEL_REWARD"] = "wheel-reward";
    Feature["DASHBOARD"] = "dashboard";
    Feature["BONUS_CODE_CASHIER"] = "bonus-code-cashier";
    Feature["DEPOSIT_BONUS_CASHIER"] = "deposit-bonus-cashier";
    Feature["CAROUSEL_LOGGED_OUT"] = "carousel-logged-out";
    Feature["BINGO_LOBBY"] = "bingo-lobby";
    Feature["GAME_PROVIDER_DROPDOWN"] = "game-provider-dropdown";
    Feature["IFRAME_GAME_PROVIDERS"] = "game-providers-loaded-via-iframe";
    Feature["ALLOWED_COUNTRIES"] = "allowed-countries";
    Feature["TIMED_TOAST_NOTIFICATIONS"] = "timed-toast-notifications";
    Feature["MERCHANT_ID"] = "merchant-id";
    Feature["TOP_NAVIGATION"] = "top-navigation";
    Feature["SAVED_DEPOSIT_CARDS"] = "saved-deposit-cards";
    Feature["DYNAMIC_CATEGORY"] = "dynamic-category-recommendations";
    Feature["GTM_ID"] = "gtm-id";
    Feature["CAROUSEL_WITHOUT_TEXT"] = "carousel-without-text";
})(exports.Feature || (exports.Feature = {}));

exports.FEATURE_QUERY_ACTIVE = FEATURE_QUERY_ACTIVE;
exports.FEATURE_QUERY_ENABLED = FEATURE_QUERY_ENABLED;
exports.FEATURE_QUERY_VALUE = FEATURE_QUERY_VALUE;
exports.FEATURE_UPDATED = FEATURE_UPDATED;
